<script setup>
import DataFilterChipsGroup from './_DataFilter/DataFilterChipsGroup.vue'
import DataFilterGroupDesktop from './_DataFilter/DataFilterGroupDesktop.vue'
import DataFilterGroupMobile from './_DataFilter/DataFilterGroupMobile.vue'

const props = defineProps({
  filters: {
    default: undefined,
  },
  label: {
    default: undefined,
  },
  maxFilterControls: {
    type: Number,
    default: 3,
  },
})

const slots = useSlots()

const count = computed(() =>
  slots?.customFilter ? props.filters?.length + 1 : props.filters?.length,
)

const processedFilters = ref([])

watch(
  () => props.filters,
  async () => {
    if (props.filters) {
      const processedFiltersLocal = props.filters
      const indexedFilters = processedFiltersLocal.map((f, i) => ({
        filter: f,
        index: i,
      }))
      const indexedPromiseFilters = indexedFilters.filter(
        indexedFilter => indexedFilter.filter.options instanceof Promise,
      )
      const results = await Promise.all(
        indexedPromiseFilters.map(filter => filter.filter.options),
      )
      results.forEach((r, i) => {
        const filterIndex = indexedPromiseFilters[i].index
        processedFiltersLocal[filterIndex].options = r
      })
      processedFilters.value = processedFiltersLocal
    }
  },
  {
    immediate: true,
  },
)
</script>

<template>
  <div class="w-full">
    <div
      class="data-filter-group position-relative flex flex-row items-end gap-4"
    >
      <template v-if="count > 0">
        <div class="data-filter-group-inputs w-full">
          <div class="data-filter-group-inputs-desktop lt-sm:!hidden">
            <DataFilterGroupDesktop
              :filters="processedFilters"
              :label="label"
              :max-filter-controls="maxFilterControls"
            >
              <template #customFilter>
                <slot name="customFilter" />
              </template>
            </DataFilterGroupDesktop>
          </div>
          <DataFilterGroupMobile
            class="data-filter-group-inputs-mobile sm:!hidden"
            :filters="processedFilters"
            :max-filter-controls="maxFilterControls"
          >
            <template #customFilter>
              <slot name="customFilter" />
            </template>
          </DataFilterGroupMobile>
        </div>
      </template>
    </div>
    <DataFilterChipsGroup :filters="processedFilters" />
  </div>
</template>
